import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@common_button';
import { makeStyles } from '@material-ui/core/styles';
import { PRIMARY_DARK } from '@theme_color';

const useStyles = makeStyles(() => ({
    title: {
        '& .MuiTypography-root': {
            color: PRIMARY_DARK,
            fontSize: 20,
            fontWeight: 600,
        },
    },
    text: {
        '&.MuiDialogContentText-root': {
            color: PRIMARY_DARK,
            fontSize: 14,
        },
    },
    btn: {
        '&.MuiDialogActions-root': {
            padding: 20,
        },
    },
}));

const ConfirmationDialog = (props) => {
    const {
        openConfirmation = false,
        setOpenConfirmation,
        handlePrintMultipleLabel,
        handlePrintLabel,
        handleRetryPrintLabel,
        setSelectedPrintLabel,
        t,
    } = props;
    const classes = useStyles();

    const onClose = () => {
        if (openConfirmation?.includes('single')) {
            setSelectedPrintLabel(null);
        }
        setOpenConfirmation(null);
    };

    const onConfirm = () => {
        if (openConfirmation === 'single') {
            handlePrintLabel();
        } else if (openConfirmation === 'single-retry') {
            handleRetryPrintLabel();
        } else {
            handlePrintMultipleLabel();
        }
    };

    return (
        <Dialog
            open={!!openConfirmation}
            onClose={onClose}
            maxWidth="sm"
        >
            <DialogTitle className={classes.title}>{t('sellerorder:Print_Label')}</DialogTitle>
            <DialogContent>
                <DialogContentText className={classes.text}>
                    {t("sellerorder:Some_channels_don't_allow_multiple_printing_of_shipping_labels_eg_Shopee")}
                    <br />
                    {t('sellerorder:Are_you_sure_you_want_to_print_shipping_label')}
                </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.btn}>
                <Button onClick={onClose} buttonType="outlined" color="primary" autoFocus>
                    {t('sellerorder:Cancel')}
                </Button>
                <Button onClick={onConfirm} color="primary">
                    {t('sellerorder:Print')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
